import { useCallback, useEffect, useState } from 'react';
import { fixedBody, jumpToPageByH5, looseBody } from '@/utils/fn';
import { reportPop, reportPopClick } from '@/utils/report';
import { openPageNative, openNativePage } from '@/utils/bridge';
import {
  INVITEE_BIND_TYPE,
  INVITEE_HAS_DEVICE_TYPE,
  INVITEE_USER_NO_DEVICE_TYPE,
  INVITEE_OLDUSER_TYPE,
} from '../config';
import styles from '../styles/common.less';

const POP_NAME = 'bind_modal';
const PAGE_NAME = 'invitee';

const InviteeBindModal = ({ visible, handleClose }) => {
  const [inviteeType, setInviteeType] = useState(INVITEE_HAS_DEVICE_TYPE);

  const handleBindModalConfirm = useCallback(() => {
    reportPopClick({
      page_name: PAGE_NAME,
      pop_name: POP_NAME,
      button_name: 'confirm',
      option: inviteeType,
    });
    looseBody();
    handleClose();
    switch (inviteeType) {
      case INVITEE_HAS_DEVICE_TYPE:
        openPageNative({ url: 'page:qr_scan?origin=0' });
        break;
      case INVITEE_USER_NO_DEVICE_TYPE:
        jumpToPageByH5('/guide/newuser?origin=bindModal');
        break;
      case INVITEE_OLDUSER_TYPE:
        openNativePage({ path: '/home', tab: 2 });
        break;
      default:
        openNativePage({ path: '/home', tab: 2 });
        break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inviteeType]);

  const handleModalClose = useCallback(() => {
    handleClose();
    reportPopClick({
      page_name: PAGE_NAME,
      pop_name: POP_NAME,
      button_name: 'close',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (visible) {
      fixedBody();
      reportPop({
        page_name: PAGE_NAME,
        pop_name: POP_NAME,
      });
    } else {
      looseBody();
    }
  }, [visible]);

  return (
    <div className={`${styles.modal} ${visible ? styles.show : styles.hide}`}>
      <div
        className={`${styles.modalContent} ${styles.bindContent}`}
        onClick={e => e.stopPropagation()}
      >
        <i
          className={`${styles['afont']} ${styles['icon-close']} ${styles.closeIcon}`}
          onClick={handleModalClose}
        />
        <h3 className={styles.modalHeader}>绑定指引</h3>
        <div className={styles.modalBody}>
          <p className={styles.bindText}>告诉小云您的状态，让您更快完成任务，获得奖励~</p>
          <ul className={styles.bindOptions}>
            {INVITEE_BIND_TYPE.map(type => (
              <li
                key={type.value}
                className={inviteeType === type.value ? styles.on : ''}
                onClick={() => setInviteeType(type.value)}
              >
                {type.text}
              </li>
            ))}
          </ul>
        </div>
        <div className={styles.modalFooter}>
          <button onClick={handleBindModalConfirm}>确定</button>
        </div>
      </div>
    </div>
  );
};
export default InviteeBindModal;
